import { CircularProgress, FormControl, FormHelperText, InputLabel, Select, SelectProps } from '@mui/material'
import { Fragment, ReactNode } from 'react'
import { FormViewerFieldMetadata } from '@omnea-app/fe-form-viewer/types'
import { useUniqueId } from '@omnea-app/frontend/utils/hooks/useUniqueId'

export interface LabeledSelectType<T> extends Omit<SelectProps<T>, 'variant'> {
  label?: ReactNode
  withLabelWrapper?: boolean
  required?: boolean
  placeholder?: string
  helperText?: ReactNode
  isLoading?: boolean
  fieldMetadata?: FormViewerFieldMetadata
  fullWidth?: boolean
}

export function LabeledSelect<T>(props: LabeledSelectType<T>) {
  const {
    label,
    required,
    placeholder,
    helperText,
    withLabelWrapper = true,
    sx,
    isLoading = false,
    fieldMetadata,
    fullWidth = true,
    ...otherProps
  } = props
  const id = useUniqueId()

  const LabelWrapper = withLabelWrapper ? InputLabel : Fragment

  return (
    <FormControl fullWidth={fullWidth}>
      {label && (
        <LabelWrapper htmlFor={id} required={required}>
          {label}
        </LabelWrapper>
      )}
      {isLoading ? (
        <CircularProgress size={16} />
      ) : (
        <>
          <Select<T>
            inputProps={{
              id,
            }}
            data-is-ai-prefilled={fieldMetadata?.isAiPrefilled}
            notched={false}
            variant="outlined"
            sx={{
              '& .MuiSelect-select .notranslate::after': placeholder
                ? {
                    content: `"${placeholder}"`,
                    opacity: 0.42,
                  }
                : {},
              ...sx,
            }}
            {...otherProps}
          >
            {props.children}
          </Select>
          {helperText && <FormHelperText error={otherProps.error}>{helperText}</FormHelperText>}
        </>
      )}
    </FormControl>
  )
}
